/**
 * Direct Select Rectangle Mode - 4 vértices editables
 * Siempre mantiene forma rectangular con ángulos de 90°
 * Al arrastrar un vértice, los dos bordes adyacentes se mueven manteniendo la perpendicularidad
 */

// @ts-nocheck
import MapboxDraw from '@mapbox/mapbox-gl-draw';

const DirectSelectMode = MapboxDraw.modes.direct_select;

// Crear modo extendiendo el original
const DirectSelectRectangleMode = { ...DirectSelectMode };

// Guardar métodos originales
const originalOnDrag = DirectSelectMode.onDrag;
const originalOnMouseDown = DirectSelectMode.onMouseDown;
const originalOnStop = DirectSelectMode.onStop;
const originalOnMouseUp = DirectSelectMode.onMouseUp;

// Permitir selección de todos los vértices
DirectSelectRectangleMode.onMouseDown = function(state: any, e: any) {
  // Permitir el comportamiento normal para todos los vértices
  if (originalOnMouseDown) {
    return originalOnMouseDown.call(this, state, e);
  }
};

// Sobrescribir onDrag para mantener forma rectangular
DirectSelectRectangleMode.onDrag = function(state: any, e: any) {
  console.log('🖱️ DirectSelectRectangleMode.onDrag llamado');

  // Si estamos arrastrando un vértice de polígono
  if (state.feature && state.feature.type === 'Polygon' && state.selectedCoordPaths && state.selectedCoordPaths.length > 0) {
    const coordPath = state.selectedCoordPaths[0];
    const draggedIndex = parseInt(coordPath.split('.')[1]);
    console.log(`   - Arrastrando vértice ${draggedIndex}`);

    // Aplicar restricciones a todos los vértices (0, 1, 2, 3)
    if (draggedIndex >= 0 && draggedIndex <= 3) {
      const coords = state.feature.coordinates[0];

      if (coords && (coords.length === 4 || coords.length === 5)) {
        // Obtener la posición del mouse
        const lng = e.lngLat.lng;
        const lat = e.lngLat.lat;

        // Orden de vértices: SW(0), SE(1), NE(2), NW(3)
        let newRect: number[][];

        if (draggedIndex === 0) {
          // Arrastrando SW: mover W y S, mantener E y N
          newRect = [
            [lng, lat],           // SW (arrastrando)
            [coords[2][0], lat],  // SE (mantener E de NE, mover S)
            coords[2],            // NE (fijo)
            [lng, coords[2][1]],  // NW (mover W, mantener N de NE)
          ];
        } else if (draggedIndex === 1) {
          // Arrastrando SE: mover E y S, mantener W y N
          newRect = [
            [coords[3][0], lat],  // SW (mantener W de NW, mover S)
            [lng, lat],           // SE (arrastrando)
            [lng, coords[3][1]],  // NE (mover E, mantener N de NW)
            coords[3],            // NW (fijo)
          ];
        } else if (draggedIndex === 2) {
          // Arrastrando NE: mover N y E, mantener W y S
          newRect = [
            coords[0],            // SW (fijo)
            [lng, coords[0][1]],  // SE (mover E, mantener S de SW)
            [lng, lat],           // NE (arrastrando)
            [coords[0][0], lat],  // NW (mantener W de SW, mover N)
          ];
        } else if (draggedIndex === 3) {
          // Arrastrando NW: mover W y N, mantener E y S
          newRect = [
            [lng, coords[1][1]],  // SW (mover W, mantener S de SE)
            coords[1],            // SE (fijo)
            [coords[1][0], lat],  // NE (mantener E de SE, mover N)
            [lng, lat],           // NW (arrastrando)
          ];
        } else {
          return;
        }

        // Actualizar coordenadas
        console.log('   - Actualizando coordenadas del rectángulo');
        state.feature.setCoordinates([newRect]);

        // NO llamar al onDrag original
        console.log('   - Coordenadas actualizadas, retornando sin llamar onDrag original');
        return;
      }
    }
  }

  // Para drag de feature completo o casos no manejados, usar comportamiento original
  if (originalOnDrag) {
    return originalOnDrag.call(this, state, e);
  }
};

// Sobrescribir onMouseUp para disparar evento cuando se suelta el vértice después de arrastrar
DirectSelectRectangleMode.onMouseUp = function(state: any, e: any) {
  console.log('🖱️⬆️ DirectSelectRectangleMode.onMouseUp llamado');
  console.log('   - state.feature:', state.feature);

  // Si hay un feature de tipo Polygon, disparar evento de actualización
  // (No podemos confiar en state.dragMoving porque ya está reseteado por el modo original)
  if (state.feature && state.feature.type === 'Polygon') {
    console.log('🔄 DirectSelectRectangleMode: Disparando draw.update después de onMouseUp');

    // Disparar evento manualmente con los datos del feature
    this.map.fire('draw.update', {
      features: [state.feature.toGeoJSON()],
      action: 'change_coordinates',
    });
  }

  // Llamar al onMouseUp original
  if (originalOnMouseUp) {
    return originalOnMouseUp.call(this, state, e);
  }
};

// Sobrescribir onStop para disparar evento de actualización cuando termina el drag
DirectSelectRectangleMode.onStop = function(state: any) {
  console.log('🛑 DirectSelectRectangleMode.onStop llamado');
  console.log('   - state:', state);
  console.log('   - state.feature:', state.feature);
  console.log('   - state.feature?.type:', state.feature?.type);

  // Disparar evento de actualización cuando se suelta el vértice
  if (state.feature && state.feature.type === 'Polygon') {
    console.log('🔄 DirectSelectRectangleMode: Disparando draw.update en onStop');

    // Disparar evento manualmente con los datos del feature
    this.map.fire('draw.update', {
      features: [state.feature.toGeoJSON()],
      action: 'change_coordinates',
    });
  } else {
    console.warn('⚠️ No se pudo disparar draw.update - state.feature no es Polygon');
  }

  // Llamar al onStop original
  if (originalOnStop) {
    return originalOnStop.call(this, state);
  }
};

export default DirectSelectRectangleMode;
